import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as myGlobals from 'src/app/globals';
import { UserOtpStatusModel, UserProfileModel } from 'src/app/models/profile.model';
import { HttpResponseModel } from 'src/app/models/response.model';
@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  constructor(private http: HttpClient) {}
  public groupName!: string;

  getUserInformation(): Observable<UserProfileModel> {
    return this.http.get<UserProfileModel>(`${myGlobals.Config.API}/users`);
  }

  updateProfile(imageData?: File): Observable<HttpResponseModel<string>> {
    const url = `${myGlobals.Config.API}/users`;
    const formData: any = new FormData();
    if (imageData) {
      formData.append('image', imageData);
    }

    const headers: HttpHeaders = new HttpHeaders().set('formdata', 'true');

    return this.http.put<HttpResponseModel<string>>(url, formData, { headers });
  }

  setLanguage(language: 'TR' | 'ENG'): Observable<HttpResponseModel<string>> {
    const params = { language };

    return this.http.put<HttpResponseModel<string>>(`${myGlobals.Config.API}/users/update-language`, {}, { params });
  }

  checkUserOtpActivated(): Observable<UserOtpStatusModel> {
    return this.http.get<UserOtpStatusModel>(`${myGlobals.Config.API}/users/check-user-otp`);
  }

  activateUserOtp(): Observable<UserOtpStatusModel> {
    return this.http.put<UserOtpStatusModel>(`${myGlobals.Config.API}/users/set-required-otp`, null);
  }
}
